/* Foil & Foundry Co. card viewer: 3D tilt with holo shine + glare, click-to-zoom lightbox, "actual photo" labels */
(function () {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- 3D tilt ---------- */
  // el = the element that tilts; zone = the element that listens for the pointer (defaults to el)
  function bindTilt(el, zone, max) {
    zone = zone || el;
    let raf = 0, last = null;
    function apply() {
      raf = 0;
      if (!last) return;
      const r = el.getBoundingClientRect();
      const px = Math.min(1, Math.max(0, (last.x - r.left) / r.width));
      const py = Math.min(1, Math.max(0, (last.y - r.top) / r.height));
      el.style.setProperty("--rx", ((py - 0.5) * max).toFixed(2) + "deg");
      el.style.setProperty("--ry", ((0.5 - px) * max).toFixed(2) + "deg");
      el.style.setProperty("--gx", (px * 100).toFixed(1) + "%");
      el.style.setProperty("--gy", (py * 100).toFixed(1) + "%");
      el.style.setProperty("--bx", (30 + px * 40).toFixed(1) + "%");
      el.style.setProperty("--by", (30 + py * 40).toFixed(1) + "%");
      el.style.setProperty("--dist", Math.min(1, Math.hypot(px - 0.5, py - 0.5) * 2).toFixed(3));
    }
    function move(e) {
      last = { x: e.clientX, y: e.clientY };
      el.classList.add("active");
      if (!raf) raf = requestAnimationFrame(apply);
    }
    function reset() {
      last = null;
      el.classList.remove("active");
      ["--rx", "--ry"].forEach((k) => el.style.setProperty(k, "0deg"));
      el.style.setProperty("--gx", "50%"); el.style.setProperty("--gy", "50%");
      el.style.setProperty("--bx", "50%"); el.style.setProperty("--by", "50%");
    }
    zone.addEventListener("pointermove", move);
    zone.addEventListener("pointerleave", reset);
    zone.addEventListener("pointercancel", reset);
    zone.addEventListener("pointerup", (e) => { if (e.pointerType === "touch") reset(); });
    reset();
  }

  if (!reduce) {
    document.querySelectorAll("[data-tilt]").forEach((el) => bindTilt(el, null, Number(el.dataset.tilt) || 16));
    // grid cards: the whole product card listens, the image inside tilts
    document.querySelectorAll(".prod").forEach((card) => {
      const t = card.querySelector(".tilt-sm");
      if (t) bindTilt(t, card, 12);
    });
  }

  /* ---------- "actual card photo" label follows the selected thumbnail ---------- */
  document.querySelectorAll("[data-product]").forEach((root) => {
    const tilt = root.querySelector("[data-tilt], .tilt");
    const badge = root.querySelector("[data-photo-badge]");
    root.querySelectorAll("[data-thumb]").forEach((b) => b.addEventListener("click", () => {
      const isPhoto = b.dataset.actual === "true";
      if (badge) badge.hidden = !isPhoto;
      if (tilt) { tilt.classList.toggle("is-photo", isPhoto); tilt.dataset.index = b.dataset.index || "0"; }
    }));
  });

  /* ---------- lightbox with zoom ---------- */
  let lb, lbImg, lbStage, lbCount, list = [], idx = 0, opener = null;
  function build() {
    lb = document.createElement("div");
    lb.className = "lightbox"; lb.hidden = true;
    lb.setAttribute("role", "dialog"); lb.setAttribute("aria-modal", "true"); lb.setAttribute("aria-label", "Card image viewer");
    lb.innerHTML =
      '<button class="lb-btn lb-close" type="button" aria-label="Close">&times;</button>' +
      '<button class="lb-btn lb-prev" type="button" aria-label="Previous image">&#8249;</button>' +
      '<div class="lb-stage"><img alt=""></div>' +
      '<button class="lb-btn lb-next" type="button" aria-label="Next image">&#8250;</button>' +
      '<p class="lb-hint"><span class="lb-count"></span> Click the card to zoom · Esc to close</p>';
    document.body.appendChild(lb);
    lbImg = lb.querySelector("img"); lbStage = lb.querySelector(".lb-stage"); lbCount = lb.querySelector(".lb-count");
    lb.querySelector(".lb-close").onclick = close;
    lb.querySelector(".lb-prev").onclick = () => show(idx - 1);
    lb.querySelector(".lb-next").onclick = () => show(idx + 1);
    lb.addEventListener("click", (e) => { if (e.target === lb) close(); });
    lbStage.addEventListener("click", (e) => {
      const z = lbStage.classList.toggle("zoomed");
      if (z) pan(e);
    });
    lbStage.addEventListener("pointermove", (e) => { if (lbStage.classList.contains("zoomed")) pan(e); });
    document.addEventListener("keydown", (e) => {
      if (lb.hidden) return;
      if (e.key === "Escape") close();
      if (e.key === "ArrowLeft") show(idx - 1);
      if (e.key === "ArrowRight") show(idx + 1);
    });
  }
  function pan(e) {
    const r = lbStage.getBoundingClientRect();
    lbImg.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
  }
  function show(i) {
    if (!list.length) return;
    idx = (i + list.length) % list.length;
    lbStage.classList.remove("zoomed");
    lbImg.src = list[idx].src; lbImg.alt = list[idx].alt || "";
    lbCount.textContent = list.length > 1 ? `${idx + 1} / ${list.length} ·` : "";
    lb.querySelector(".lb-prev").hidden = lb.querySelector(".lb-next").hidden = list.length < 2;
  }
  function open(root, start) {
    if (!lb) build();
    opener = document.activeElement;
    const thumbs = Array.from(root.querySelectorAll("[data-thumb]"));
    const main = root.querySelector("[data-main-img]");
    list = thumbs.length ? thumbs.map((b) => ({ src: b.dataset.full || b.dataset.thumb, alt: b.getAttribute("aria-label") })) : main ? [{ src: main.dataset.full || main.src, alt: main.alt }] : [];
    lb.hidden = false; document.documentElement.style.overflow = "hidden";
    show(start);
    lb.querySelector(".lb-close").focus();
  }
  function close() {
    lb.hidden = true; document.documentElement.style.overflow = "";
    if (opener && opener.focus) opener.focus();
  }
  document.querySelectorAll("[data-product]").forEach((root) => {
    const t = root.querySelector("[data-zoom]");
    if (!t) return;
    const go = () => {
      const cur = root.querySelector('[data-thumb][aria-current="true"]');
      open(root, cur ? Number(cur.dataset.index) || 0 : 0);
    };
    t.addEventListener("click", go);
    t.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); go(); } });
  });
})();
